export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '姓名',
    dataIndex: 'true_name',
  },
  {
    title: '开户行',
    dataIndex: 'bank_deposit',
  },
  {
    title: '银行卡号',
    dataIndex: 'card_number',
  },
  {
    title: '提现金额',
    dataIndex: 'cash_money',
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '申请时间',
    dataIndex: 'create_time',
  },
  {
    title: '审核时间',
    dataIndex: 'check_time',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];
export const formData1 = [
  {
    name: 'status',
    lable: '状态',
    lableCol: 4,
    wrapperCol: 16,
  },
];
export const formData2 = [
  {
    name: 'status',
    lable: '状态',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'reason',
    lable: '说明',
    lableCol: 4,
    wrapperCol: 18,
  },

];
export const formData3 = [
  {
    name: 'img_id',
    lable: '上传凭证',
    lableCol: 4,
    wrapperCol: 18,
  },
];

